<div class="card p-3 mt-2">
    <nz-skeleton [nzLoading]="loading" [nzActive]="true" class="d-flex flex-column">
      <div class="title">QRIS History</div>
      <div class="flex flex-col gap-12 p-4">
        <div class="flex flex-col text-darkGray">
          <span class="text-[16px] font-semibold">Generate Dynamic QRIS</span>
          <span class="text-[12px] text-[#667085]"
            >Easily create dynamic payment QR codes in just a few steps.</span
          >
        </div>

        <div class="flex flex-col lg:flex-row gap-4 w-full">
          <!-- Input section -->
          <div class="flex flex-col gap-6 w-full lg:w-1/2">
            <div class="flex flex-col gap-2">
              <span class="text-[16px] font-semibold text-[#101828]">Amount (IDR)</span>
              <input
                nz-input
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                [(ngModel)]="amount"
                (ngModelChange)="onAmountChange($event)"
                (keydown)="onlyNumber($event)"
                placeholder="Enter amount (e.g. 25000)"
                class="rounded-lg h-11"
              />
            </div>
            <div class="flex flex-col gap-2">
              <span class="text-[16px] font-semibold text-[#101828]">QRIS List</span>
              <nz-select
                [(ngModel)]="selectedQRIS"
                nzPlaceHolder="Choose your QRIS list"
                class="w-full rounded-lg"
                [nzSize]="'large'"
              >
                <nz-option *ngFor="let item of qrisList" [nzValue]="item.id" [nzLabel]="item.name"></nz-option>
              </nz-select>
            </div>

            <button nz-button [nzType]="!amount || !selectedQRIS ? 'default' : 'primary'" (click)="generateQris()" [disabled]="!amount || !selectedQRIS" class="w-full h-11">Generate Dynamic QRIS</button>
          </div>

          <!-- Preview Section -->
          <div class="flex flex-col gap-6 w-full lg:w-1/2">
            <app-generated-qris [data]="generatedData" [isGenerated]="isGenerated"></app-generated-qris>
          </div>
        </div>

        <app-table-history-qris></app-table-history-qris>
      </div>
    </nz-skeleton>
</div>
<app-modal-insufficient-balance
  [isVisible]="isInsufficientBalance"
  (cancel)="isInsufficientBalance = false"
  (confirm)="handleTopUp()"
></app-modal-insufficient-balance>
